import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { t } from '@lib/translation';
import { SnLprHotList } from '@lib/vehicle-intelligence';

import { SnMapView, SnUser } from '../../../../api/entities/src';

@Injectable({ providedIn: 'root' })
export class FsDolpShareService {
  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _toastrService: ToastrService,
  ) {}

  public getUsersBrief(params?: ISnListQueryParameters): Observable<ISnListResponse<SnUser>> {
    return this._httpClient.get('/api/users/brief/', { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        results: response.results.map((user) => new SnUser(user)),
      })),
    );
  }

  public getMapViewDolp(id: string): any {
    return this._httpClient.get(`/api/map-views/${id}/dolp/`).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  public getLprHotlistDolp(id: string): any {
    return this._httpClient.get(`/api/lpr/hotlists/${id}/dolp/`).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  public addMapViewDolp(id: string, data: SnMapView | any): any {
    return this._httpClient.post(`/api/map-views/${id}/dolp/`, data).pipe(
      tap({
        next: () => this._toastrService.success(t('share.usersAddedToMapView')),
        error: () => this._toastrService.error(t('share.couldNotUpdateMapView')),
      }),
    );
  }

  public addLprHotlistDolp(id: string, data: SnLprHotList | any): any {
    return this._httpClient.post(`/api/lpr/hotlists/${id}/dolp/`, data).pipe(
      tap({
        next: () => this._toastrService.success(t('share.usersAddedToHotlist')),
        error: () => this._toastrService.error(t('share.couldNotUpdateHotlist')),
      }),
    );
  }
}
